import s from "./Services.module.css";
import { cn } from "@/lib/utils.js";
import services from "@/components/home/Services/services.js";
import { Heading } from "../../ui/heading";

function Services() {
  return (
    <div className="bg-brand-blue w-full shadow-inner py-32 mt-32">
      <div className="container mx-auto">
        <div className="flex justify-center">
          <Heading className="text-6xl pb-16" size="h2">Услуги</Heading>
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-4 px-4 xl:px-0">
          {services.map((item, i) => (
            <div className="" key={`service-item-${i}`}>
              <div className="text-center flex flex-col space-y-8 mb-8 box-content items-center mx-auto">
                <div
                  className={cn(
                    "border-white border-8 bg-gray-200 shadow-lg w-32 h-32 lg:w-48 lg:h-48 justify-center items-center flex",
                    s["shape-2"]
                  )}
                >
                  <img
                    src={item.image}
                    width={90}
                    height={90}
                    alt={item.name}
                  />
                </div>
                <div className="font-bold text-lg lg:text-2xl">{item.name}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Services;
